/// <reference path="../typings/index.d.ts" />
/// <reference path="SocketIo.d.ts" />

namespace App {
  export class SocketIo implements ISocketIo {
    public socket: any = null;
    public inicializarCampo(urlServer: string = "http://localhost:5033", idUser: number, token: string, ip: string = null, senha: string = null, porta: number = null): void {
      this.socket = io(urlServer, {
        query: { id: idUser, token: token, origin: window.location.origin, ip: ip, senha: senha, porta: porta }
      });
      return this.socket;
    }
  }
}
